import type { DriveStep } from 'driver.js';

export const dashboardTourSteps: DriveStep[] = [
  {
    element: '[data-tour="dashboard-kpis"]',
    popover: {
      title: 'Deine Kennzahlen',
      description: 'Klienten, Sitzungen, offene Rechnungen und Monatsumsatz — alles auf einen Blick mit Trend-Vergleich zum Vormonat.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="dashboard-chart"]',
    popover: {
      title: 'Umsatz-Verlauf',
      description: 'Dein Umsatz und deine Sitzungen der letzten Monate als Diagramm. Hover für Details.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="dashboard-actions"]',
    popover: {
      title: 'Schnellzugriff',
      description: 'Die wichtigsten Aktionen direkt starten: Klient anlegen, Sitzung planen, Rechnung erstellen.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="dashboard-messages"]',
    popover: {
      title: 'Nachrichten',
      description: 'Deine letzten Konversationen mit ungelesenen Nachrichten. Klicke auf eine, um direkt zu antworten.',
      side: 'left',
      align: 'start',
    },
  },
  {
    element: 'a[href="/klienten"]',
    popover: {
      title: 'Klienten verwalten',
      description: 'Alle deine Coaching-Klienten an einem Ort. Anlegen, bearbeiten, Fälle und Sitzungen verwalten.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: 'a[href="/nachrichten"]',
    popover: {
      title: 'Nachrichten',
      description: 'Dein Posteingang. Chat mit Klienten, Auto-Antworten einrichten, Archiv verwalten.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: 'a[href="/rechnungen"]',
    popover: {
      title: 'Rechnungen & Mahnwesen',
      description: 'Rechnungen erstellen, als ZUGFeRD-PDF versenden und das 4-Stufen-Mahnwesen nutzen.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: 'a[href="/hilfe"]',
    popover: {
      title: 'Hilfe & Playbook',
      description: '22 ausführliche Artikel zu allen Funktionen. Dein Nachschlagewerk für CoachDesk365.',
      side: 'right',
      align: 'start',
    },
  },
];
